export default "__VITE_ASSET__c752d077__"